import { BlogInterface } from "../../constants/Blog";
import CategorizedHorizontalBlogCard from "./CategorizedHorizontalBlogCard";
import { SimpleGrid, SimpleGridProps } from "@chakra-ui/react";

interface Props extends SimpleGridProps {
  data: BlogInterface[] | undefined;
}
const HighlightBlogs = ({ data, ...rest }: Props) => {
  return (
    <SimpleGrid columns={{ base: 1, md: 2 }} gap={4} {...rest}>
      {data?.map((blog, index) => (
        <CategorizedHorizontalBlogCard
          key={index}
          category={blog.category_name}
          imageSrc={
            blog.thumbnail
              ? `${process.env.REACT_APP_MEDIA_URL}${blog.thumbnail}`
              : ""
          }
          title={blog?.title}
          slug={blog?.slug}
          description={blog?.preview}
          postDate={blog?.posted_date}
        />
      ))}
    </SimpleGrid>
  );
};

export default HighlightBlogs;
